// UDD (Undisclosed Drivers) auto-approve gating constants.
//
// Lives under `config/` because the values are pure data — they belong with
// the rest of the task metadata that's safe to import from both frontend and
// backend bundles. The shared client and lambdas re-import these to decide
// whether a task can skip staff review and trigger the original-term NRI
// endorsement automatically.
//
// See: https://github.com/gobranch/branch/issues/24253 (UDD Phase 6).

import { driverRemovedReasons } from '@ourbranch/lookups';

/**
 * driverRemovedReason values that trigger automatic task approval for a
 * ReviewPotentialUndisclosedDriver submission (no staff review required).
 * For every other valid reason, the task routes to UW Ops / Processing and
 * the NRI update fires once a staff reviewer approves the task.
 */
export const UDD_AUTO_APPROVE_REMOVED_REASONS: readonly string[] = [
  driverRemovedReasons.CONFIRMED_DRIVER,
  driverRemovedReasons.DECEASED,
  driverRemovedReasons.UNKNOWN,
  driverRemovedReasons.PRIOR_OWNER,
  driverRemovedReasons.DUPLICATE
];

export const isUddAutoApproveRemovedReason = (reason: unknown): reason is string =>
  typeof reason === 'string' && UDD_AUTO_APPROVE_REMOVED_REASONS.includes(reason);
